import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFilter } from "react-icons/fa";

const FilterPost = ({isFilterActive, translation, Navtranslation, handleTabClick}) => {
  const [filterData, setFilterData] = useState({});
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleFilter = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilterData({ ...filterData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const queryParams = Object.entries(filterData)
      .filter(([key, value]) => value !== '') 
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    const url = queryParams ? `/filter?${queryParams}` : '/'; 
    navigate(url);
    
    // Close sidebar after search
    if (handleTabClick) {
      handleTabClick();
    }
  };

  return (
    <div className="w-full min-w-[220px]">
      <div className="relative mb-3">
        <button 
          className={`flex w-full items-center hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg p-2 dark:text-white transition-colors
            ${isFilterActive ? "bg-slate-200 dark:bg-slate-800" : ""}`}
          onClick={handleFilter}
          aria-expanded={isOpen}
          aria-haspopup="true"
        >
          <FaFilter className="w-5 h-5" />
          <p className="px-5 text-sm font-medium">{translation.filter_name}</p>
        </button>

        <div
          className={`${isOpen ? "block" : "hidden"} w-full rounded-md`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="account-menu"
        > 
          <form onSubmit={handleSubmit} className='grid grid-cols-1 gap-2 mb-3 space-y-1 px-3'>            
            <div className='flex flex-col '>
              <label htmlFor='support' className='text-sm w-full font-medium text-slate-950 block dark:text-white'>{translation.support}</label>
              <select id='support' name='support' onChange={handleChange} className='az-input-btn'>
                <option value=''>{translation.select}</option>
                <option value='family case'>{Navtranslation.family_case}</option>
                <option value='medical case'>{Navtranslation.medical_case}</option>
                <option value='marriage case'>{Navtranslation.marriage_case}</option>
                <option value='madrasa case'>{Navtranslation.madrasa_case}</option>
                <option value='masjid case'>{Navtranslation.masjid_case}</option>
              </select>
            </div>
            

            <div className='flex flex-col '>
              <label htmlFor='need' className='text-sm w-full font-medium text-slate-950 block dark:text-white'>{translation.support_by}</label>
              <select id='need' name='need' onChange={handleChange} className='az-input-btn'>
                <option value=''>{translation.select}</option>
                <option value='zakat'>{translation.support_by_sub.zakat}</option>
                <option value='donation'>{translation.support_by_sub.donation}</option>
                <option value='help'>{translation.support_by_sub.help}</option>
                <option value='anything'>{translation.support_by_sub.anything}</option>
              </select>
            </div>

            <div className='flex flex-col'>
              <label htmlFor='need_amount_min' className='text-sm w-full font-medium text-slate-950 block dark:text-white'>{translation.how_much}</label>
              <input type='number' id='need_amount_min' name='need_amount_min' className='az-input-btn' onChange={handleChange} placeholder='0'/>
            </div>

            <div className='flex flex-col'>
              <label htmlFor='address' className='text-sm w-full font-medium text-slate-950 block dark:text-white'>{translation.seeker_add}</label>
              <input type='text' id='address' name='address' className='az-input-btn' onChange={handleChange} placeholder='karachi'/>
            </div>

            <div className='flex flex-col'>
              {/* <label htmlFor='bank_name' className='text-sm w-full font-medium text-slate-950 block dark:text-white'>{translation.seeker_bank}</label>
              <input type='text' id='bank_name' name='bank_name' className='az-input-btn' onChange={handleChange} placeholder='Bank Name' /> */}

              <button type='submit' className='bg-blue-500 hover:bg-blue-600 text-white p-2 rounded px-1 text-sm w-full mt-3 transition-colors'>
                {translation.search}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FilterPost;